import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InitialisePaymentResult } from '../models/payment/initialise-payment-result.model';
import { PaymentDetails } from '../models/payment/payment-details.model';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient) { }

  public getPaymentDetails(): Observable<PaymentDetails> {
    return this.http.get<PaymentDetails>(`${this.appConfigService.getConfig().apiUrl}debtor/payment`);
  }

  public initialisePayment(amount: number, accountIds: Array<string>, countryId: string, method: string, debtCurrency: string, methodCurrency: string):
    Observable<InitialisePaymentResult> {
    return this.http.post<InitialisePaymentResult>(`${this.appConfigService.getConfig().apiUrl}debtor/payment/initialise`, { amount, accountIds, countryId, method, debtCurrency, methodCurrency });
  }

  public sendPaymentReceipt(receiptId: string, emailAddress: string): Observable<any> {
    return this.http.post<any>(`${this.appConfigService.getConfig().apiUrl}debtor/payment/receipt`, { receiptId, emailAddress });
  }
}
